<audio></audio>

<div class="dialog-title-content"
     cdkDrag
     cdkDragRootElement=".cdk-overlay-pane"
     cdkDragHandle>
  <div class="dialog-title">{{'common.dialog.softPhoneDialog.title' | translate}}</div>
  <div class="dialog-close" (click)="closeDialog(false)">
    <mat-icon>power_settings_new</mat-icon>
  </div>
  <div class="dialog-close" (click)="minimize()">
    <mat-icon>close</mat-icon>
  </div>
</div>

<div class="dialog-content no-overflow">
  <div class="dialog-loading" *ngIf="(isReady | async) === false">
    <mat-spinner diameter="36"></mat-spinner>
    <span>{{'common.dialog.softPhoneDialog.phoneLabels.connecting' | translate}}</span>
  </div>
  <div class="soft-phone">
    <div class="df jc-s ai-c gap20">
      <div class="df-c grow" *ngIf="!callInProgress" style="position: relative">
        <mat-label class="light-label">{{'common.dialog.softPhoneDialog.phoneLabels.phoneNumber' | translate}}</mat-label>
        <input matInput type="text" [formControl]="phone" class="phone-number-field"
               (paste)="onInputPaste($event.clipboardData?.getData('text/plain'))">
        <div class="field-action-button custom-field" *ngIf="managers.length">
          <button class="item-action-button gray" [matMenuTriggerFor]="managersListMenu">
            <mat-icon>people</mat-icon>
          </button>
        </div>
        <mat-menu #managersListMenu xPosition="before">
          <button mat-menu-item class="item-action-button gray" *ngFor="let manager of managers" (click)="phone.setValue(manager.sipLogin?.substr(2))">
            {{manager.sipLogin?.substr(2)}}
            {{'-'}}
            {{manager.name}}
          </button>
        </mat-menu>
      </div>

      <div *ngIf="callInProgress" class="clickable df-c grow"
           (click)="openCrmGlobalSearchDialog(incomingCall ? newRTCSession.remote_identity.display_name : phone.value)">
        <div class="df gap10">
          <mat-label class="light-label">
            {{incomingCall ? ('common.dialog.softPhoneDialog.phoneLabels.incoming' | translate) : ('common.dialog.softPhoneDialog.phoneLabels.outgoing' | translate)}}
          </mat-label>
          <div *ngIf="callConnected">{{callTimerString}}</div>
        </div>

        <div class="phone-number-field progress">
          {{incomingCall ? newRTCSession.remote_identity.display_name : phone.value}}
        </div>
        <div>{{callState?.callData?.name ? callState?.callData?.name : ''}}</div>
      </div>

      <button class="phone-button call active" style="width: 40px; min-width: 40px; max-width: 40px" (click)="call()" *ngIf="!callInProgress || incomingCall">
        <mat-icon>call</mat-icon>
      </button>
      <button class="phone-button end-call active" style="width: 40px; min-width: 40px; max-width: 40px" (click)="endCall()" *ngIf="callInProgress">
        <mat-icon>call_end</mat-icon>
      </button>
    </div>

    <mat-divider class="divider"></mat-divider>

    <div class="phone-buttons df gap20">
      <div style="width: 85px; min-width: 85px; max-width: 85px gap: 4px;" class="df-c jc-s ai-c">
        <button class="phone-button mic" (click)="toggleCallMute()" [disabled]="!callConnected || callOnHold" [ngClass]="{'active': callMuted}">
          <mat-icon>mic_off</mat-icon>
        </button>
        <span class="button-text">{{'common.dialog.softPhoneDialog.phoneLabels.mic' | translate}}</span>
      </div>
      <div style="width: 85px; min-width: 85px; max-width: 85px; gap: 4px;" class="df-c jc-s ai-c">
        <button class="phone-button hold" (click)="toggleCallHold()" [disabled]="!callConnected" [ngClass]="{'active': callOnHold}">
          <mat-icon>pause</mat-icon>
        </button>
        <span class="button-text">{{'common.dialog.softPhoneDialog.phoneLabels.hold' | translate}}</span>
      </div>
      <div style="width: 85px; min-width: 85px; max-width: 85px; gap: 4px;" class="df-c jc-s ai-c">
        <button class="phone-button redirect" (click)="redirectOpened = !redirectOpened" [disabled]="!callConnected" [ngClass]="{'active': redirectOpened}">
          <mat-icon>swap_calls</mat-icon>
        </button>
        <span class="button-text">{{'common.dialog.softPhoneDialog.phoneLabels.redirect' | translate}}</span>
      </div>
    </div>
  </div>

  <div class="redirect-container" *ngIf="redirectOpened && callConnected">
    <div class="redirect-number df jc-s ai-e gap20">
      <div class="df-c grow">
        <mat-label class="light-label">{{'common.dialog.softPhoneDialog.phoneLabels.phoneNumber' | translate}}</mat-label>
        <input matInput [formControl]="dtmf" class="phone-number-field"
               (paste)="onInputPaste($event.clipboardData?.getData('text/plain'))">
      </div>
      <button class="phone-button call active" style="width: 40px; min-width: 40px; max-width: 40px" (click)="redirectCall(); redirectOpened = !redirectOpened" *ngIf="!callInProgress || incomingCall">
        <mat-icon>phone_forwarded</mat-icon>
      </button>
    </div>

    <mat-label class="light-label">{{'common.dialog.softPhoneDialog.phoneLabels.manager' | translate}}</mat-label>
    <div class="subscribers-container">
      <div class="subscribers-list">
        <div class="subscriber clickable" *ngFor="let subscriber of managers" (click)="redirectCall(subscriber.sipLogin!)">
          <span matTooltip="{{subscriber.sipLogin}}">{{subscriber.name}}</span>
        </div>
      </div>
    </div>
  </div>
</div>
